import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";

import { i18n } from "services/i18nService";

import { useRelated } from "hooks/useRelated";

export function FrmCustomer(props) {
  const {
    value,
    onValueChange,
    label = i18n("frmLabel.Customer"),
    disabled,
    sx,
    error,
  } = props;

  const customers = useRelated("customer");

  return (
    <FrmSelectFromObjects
      name="customer"
      options={customers}
      disabled={disabled}
      value={value}
      label={label}
      onValueChange={onValueChange}
      error={error}
      sx={sx}
    />
  );
}
